const topics = [
  { name: '娱乐圈八卦', count: '3.2万', hot: true },
  { name: '明星恋情', count: '2.8万', hot: true },
  { name: '网红翻车', count: '2.1万', hot: true },
  { name: '直播内幕', count: '1.9万', hot: false },
  { name: '企业黑料', count: '1.7万', hot: false },
  { name: '综艺黑幕', count: '1.5万', hot: false },
  { name: '音乐抄袭', count: '1.3万', hot: true },
  { name: '社会事件', count: '1.2万', hot: false },
  { name: '隐私泄露', count: '8.6千', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-hashtag"></i>
            热门标签
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            话题热榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            黑料网下载热门话题标签，发现你最感兴趣的吃瓜方向
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <div
                key={i}
                className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all hover:scale-105 ${
                  topic.hot
                    ? 'bg-accent-100/60 border-accent-200 text-accent-800 hover:bg-accent-200/60'
                    : 'bg-background-50 border-secondary-200 text-foreground-600 hover:border-primary-200 hover:text-primary-500'
                }`}
              >
                {topic.hot && (
                  <span className="flex items-center">
                    <i className="ri-fire-fill text-accent-500 text-sm"></i>
                  </span>
                )}
                <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
                <span className={`text-xs ${
                  topic.hot ? 'text-accent-500' : 'text-foreground-400'
                }`}>
                  {topic.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}